var app = angular.module("leonardo");

var OnDemandInstructionsStates = function($stateProvider) {
  $stateProvider.state('on-demand-instructions', {
    url: '/on-demand-instructions',
    parent: 'authenticated.layout-main',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'on-demand-instructions.list',
    ncyBreadcrumb: {
      label: 'On demand instructions'
    }
  });

  $stateProvider.state('on-demand-instructions.list', {
    url: '/list',
    only_filter_account:true,
    views: {
      'user@authenticated.layout-main': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/list.html',
        controller: 'OnDemandInstructionsList'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersController'
      }
    },
    ncyBreadcrumb: {
      label: 'Library'
    }
  });

  $stateProvider.state('on-demand-instructions.unread', {
    url: '/unread/:pk',
    params: {
      pk: '',
      squash: false
    },
    only_filter_account:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/category.html',
        controller: 'OnDemandInstructionsUnread'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersController'
      }
    },
    ncyBreadcrumb: {
      label: 'Unread Instructions'
    }
  });

  $stateProvider.state('on-demand-instructions.instructions', {
    url: '/instructions',
    only_filter_account:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/instructions.html',
        controller: 'OnDemandInstructionsController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/on-demand-instructions-list.html',
        controller: 'OnDemandInstructionActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersInstructions'
      }
    },
    ncyBreadcrumb: {
      label: 'Edit Instructions'
    }
  });

  $stateProvider.state('on-demand-instructions.categories', {
    url: '/categories',
    only_filter_account:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/categories.html',
        controller: 'OnDemandCategoriesController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/on-demand-categories-list.html',
        controller: 'OnDemandInstructionActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersController'
      }
    },
    ncyBreadcrumb: {
      label: 'Edit Categories'
    }
  });

  $stateProvider.state('on-demand-instructions.subcategories', {
    url: '/subcategories',
    only_filter_account:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/subcategories.html',
        controller: 'OnDemandSubCategoriesController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/on-demand-subcategories-list.html',
        controller: 'OnDemandInstructionActions'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersSubcategories'
      }
    },
    ncyBreadcrumb: {
      label: 'Edit Subcategories'
    }
  });

  $stateProvider.state('on-demand-instructions.instruction-add', {
    url: '/instruction/add',
    action: 'create',
    title: 'Add On demand instruction',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/form.html',
        controller: 'OnDemandInstructionController'
      }
    },
    resolve: {
      instructionObj: ['OnDemandInstructionService', function(OnDemandInstructionService) {
        return OnDemandInstructionService.bulkObject();
      }]
    },
    ncyBreadcrumb: {
      label: 'Add On demand instruction'
    }
  });

  $stateProvider.state('on-demand-instructions.category-add', {
    url: '/category/add',
    action: 'create',
    title: 'Add Category',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/form-category.html',
        controller: 'OnDemandCategoryController'
      }
    },
    resolve: {
      categoryObj: ['OnDemandCategoryService', function(OnDemandCategoryService) {
        return OnDemandCategoryService.bulkObject();
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Category'
    }
  });

  $stateProvider.state('on-demand-instructions.subcategory-add', {
    url: '/subcategory/add',
    action: 'create',
    title: 'Add Subcategory',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/form-subcategory.html',
        controller: 'OnDemandSubCategoryController'
      }
    },
    resolve: {
      categoryObj: ['OnDemandSubCategoryService', function(OnDemandSubCategoryService) {
        return OnDemandSubCategoryService.bulkObject();
      }]
    },
    ncyBreadcrumb: {
      label: 'Add Subcategory'
    }
  });

  $stateProvider.state('on-demand-instructions.instruction', {
    url: '/instruction/:pk',
    params: {
      pk: '',
      squash: false
    },
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/detail.html',
        controller: 'OnDemandInstructionsDetail'
      }
    },
    ncyBreadcrumb: {
      label: 'On demand instruction'
    }
  });

  $stateProvider.state('on-demand-instructions.instruction-edit', {
    url: '/instruction/:pk/edit',
    params: {
      pk: '',
      squash: false
    },
    action: 'edit',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/form.html',
        controller: 'OnDemandInstructionController'
      }
    },
    resolve: {
      instructionObj: ['OnDemandInstructionService', '$stateParams', function(OnDemandInstructionService, $stateParams) {
        return OnDemandInstructionService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'Edit On demand instruction'
    }
  });

  $stateProvider.state('on-demand-instructions.category', {
    url: '/category/:pk',
    params: {
      pk: '',
      squash: false
    },
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/category.html',
        controller: 'OnDemandCategoryDetail'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersController'
      }
    },
    resolve: {
      categoryObj: ['OnDemandCategoryService', '$stateParams', function(OnDemandCategoryService, $stateParams) {
        return OnDemandCategoryService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'On demand Category'
    }
  });

  $stateProvider.state('on-demand-instructions.category-edit', {
   url: '/category/:pk/edit',
   params: {
    pk: '',
    squash: false
  },
   action: 'edit',
   views: {
     'content@authenticated.layout-main': {
       templateUrl: 'views/templates/on-demand-instructions/form-category.html',
       controller: 'OnDemandCategoryController'
     }
   },
   resolve: {
     categoryObj: ['OnDemandCategoryService', '$stateParams', function(OnDemandCategoryService, $stateParams) {
       return OnDemandCategoryService.get($stateParams.pk);
     }]
   },
   ncyBreadcrumb: {
     label: 'Edit On demand Category'
   }
  });

  $stateProvider.state('on-demand-instructions.subcategory', {
    url: '/subcategory/:pk?category',
    params: {
      pk: '',
      squash: false
    },
    subcategory:true,
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/on-demand-instructions/category.html',
        controller: 'OnDemandCategoryDetail'
      },
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'OnDemandFiltersController'
      }
    },
    resolve: {
      categoryObj: ['OnDemandSubCategoryService', '$stateParams', function(OnDemandSubCategoryService, $stateParams) {
        return OnDemandSubCategoryService.get($stateParams.pk);
      }]
    },
    ncyBreadcrumb: {
      label: 'On demand Subcategory'
    }
  });

  $stateProvider.state('on-demand-instructions.subcategory-edit', {
   url: '/subcategory/:pk/edit',
   params: {
    pk: '',
    squash: false
  },
   action: 'edit',
   views: {
     'content@authenticated.layout-main': {
       templateUrl: 'views/templates/on-demand-instructions/form-subcategory.html',
       controller: 'OnDemandSubCategoryController'
     }
   },
   resolve: {
     categoryObj: ['OnDemandSubCategoryService', '$stateParams', function(OnDemandSubCategoryService, $stateParams) {
       return OnDemandSubCategoryService.get($stateParams.pk);
     }]
   },
   ncyBreadcrumb: {
     label: 'Edit On demand Subcategory'
   }
  });

};

app.config(['$stateProvider', OnDemandInstructionsStates]);
